module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0